import React from 'react';
import { MessageSquare, Truck, HardHat } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
export function AnnouncementBar() {
  const location = useLocation();
  const isContractors = location.pathname.includes('subcontractors') || location.pathname.includes('contractors');
  const bgColor = isContractors ? 'bg-[#C24A27]' : 'bg-[#1e6b30]';
  const borderColor = isContractors ? 'border-[#A33E22]' : 'border-[#1a5f2a]';
  return <div className={`${bgColor} text-white py-2 px-4 text-xs sm:text-sm font-medium relative z-[60] transition-colors duration-300 border-b ${borderColor}`} data-id="element-129">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-3 sm:gap-4" data-id="element-130">
        <div className="flex items-center" data-id="element-131">
          <Truck className="w-4 h-4 mr-1.5 hidden sm:block" data-id="element-132" />
          <span className="hidden sm:inline" data-id="element-133">
            Bulk Delivery Across South King County
          </span>
          <span className="sm:hidden" data-id="element-134">Bulk Delivery Available</span>
        </div>
        <span className="opacity-50" data-id="element-135">|</span>
        <a href="tel:206-619-3742" className="flex items-center hover:text-white/80 transition-colors font-bold" data-id="element-136">
          (206) 619-3742
        </a>
        <span className="opacity-50" data-id="element-137">|</span>
        <Link to="/subcontractors" className="flex items-center text-white hover:text-white/80 transition-colors font-bold" data-id="element-138">
          <HardHat className="w-3.5 h-3.5 sm:w-4 sm:h-4 mr-1" data-id="element-139" />
          Contractors
        </Link>
      </div>
    </div>;
}